import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export default function PaymentCancelled() {
  const { t } = useLanguage();
  const pc = t.paymentCancelled;

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6" data-testid="payment-cancelled-page">
      <div className="max-w-md w-full text-center">
        <XCircle className="w-14 h-14 text-neutral-500 mx-auto mb-6" />
        <h1 className="font-heading text-2xl font-bold mb-3">{pc.title}</h1>
        <p className="text-neutral-400 text-sm mb-8">{pc.subtitle}</p>
        <Link
          to="/#planes"
          data-testid="payment-cancelled-back-button"
          className="inline-flex items-center gap-2 text-sm font-semibold text-white px-6 py-3 rounded-full border border-white/15 hover:bg-white/[0.06] transition-all duration-300"
        >
          <ArrowLeft className="w-4 h-4" /> {pc.backButton}
        </Link>
      </div>
    </div>
  );
}
